import { Diagnostic, Rule } from "@siteimprove/alfa-act";
import { DOM } from "@siteimprove/alfa-aria";
import { Element, Namespace, Node, Query } from "@siteimprove/alfa-dom";
import { Predicate } from "@siteimprove/alfa-predicate";
import { Err, Ok } from "@siteimprove/alfa-result";
import { Criterion } from "@siteimprove/alfa-wcag";
import { expectation } from "../common/act/expectation.js";
import { Scope, Stability } from "../tags/index.js";
const { hasNonEmptyAccessibleName, hasRole, isIncludedInTheAccessibilityTree } = DOM;
const { hasInputType, hasNamespace } = Element;
const { and, not } = Predicate;
const { getElementDescendants } = Query;
export default Rule.Atomic.of({
    uri: "https://alfa.siteimprove.com/rules/sia-r12",
    requirements: [Criterion.of("4.1.2")],
    tags: [Scope.Component, Stability.Stable],
    evaluate({ device, document }) {
        return {
            applicability() {
                return getElementDescendants(document, Node.fullTree).filter(and(not(hasInputType("image")), hasNamespace(Namespace.HTML), hasRole(device, "button"), isIncludedInTheAccessibilityTree(device)));
            },
            expectations(target) {
                return {
                    1: expectation(hasNonEmptyAccessibleName(device)(target), () => Outcomes.HasName, () => Outcomes.HasNoName),
                };
            },
        };
    },
});
/**
 * @public
 */
export var Outcomes;
(function (Outcomes) {
    Outcomes.HasName = Ok.of(Diagnostic.of(`The button has an accessible name`));
    Outcomes.HasNoName = Err.of(Diagnostic.of(`The button does not have an accessible name`));
})(Outcomes || (Outcomes = {}));
//# sourceMappingURL=rule.js.map